import React from "react";

import langeEn from "./constants/lang/en";


const LanguageContext = React.createContext({ lang: langeEn });
export default LanguageContext;
